import { styled } from "goober";
import { spin } from "../motion";

export const ActivityRing = styled("span")`
  display: block;
  flex-shrink: 0;
  border-radius: 50%;
  box-sizing: border-box;
  padding: 1px;
  background: conic-gradient(
    from 90deg,
    var(--pink-600) 0deg 180deg,
    var(--sky-600) 180deg 270deg,
    var(--orange-600) 270deg 313.2deg,
    var(--teal-600) 313.2deg 360deg
  );
  -webkit-mask:
    repeating-conic-gradient(#fff 0deg 15deg, transparent 15deg 20deg),
    linear-gradient(#fff 0 0) content-box;
  -webkit-mask-composite: source-out;
  mask:
    repeating-conic-gradient(#fff 0deg 15deg, transparent 15deg 20deg),
    linear-gradient(#fff 0 0) content-box;
  mask-composite: subtract;
  animation: ${spin} 3000ms linear infinite;
`;
